export const ApiBaseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8004/api";
export const LocalApiBaseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8004/api";
export const SocketBaseURL = process.env.REACT_APP_SOCKET_BASE_URL || "http://localhost:8004";

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
};

export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";